import McEmptyContent from './McEmptyContent';

export default McEmptyContent;
